/* WiseCar V4 ana sayfa etkileşimleri: kaydırınca belirme, giriş paralaksı, öne çıkanlar vitrini, model şeridi okları, belge önizleme. */
(function () {
  if (window.__wc4Home) return;
  window.__wc4Home = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);

  function reveal(root) {
    var els = root.querySelectorAll('.reveal:not(.in)');
    if (!('IntersectionObserver' in window) || reduce || design) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function hero(root) {
    var el = root.querySelector('.hero');
    if (!el || reduce || el.dataset.wc4Init) return;
    el.dataset.wc4Init = '1';
    var imgs = el.querySelectorAll('.duo__img'), glow = el.querySelector('.hero__glow'), ticking = false;
    function onScroll() {
      var top = el.getBoundingClientRect().top + window.scrollY;
      var p = Math.min(1, Math.max(0, (window.scrollY - top) / (el.offsetHeight * 0.7)));
      imgs.forEach(function (img, i) {
        var dir = i === 0 ? -1 : 1;
        img.style.transform = 'translate(' + (dir * p * 24) + 'px,' + (-p * (i === 0 ? 40 : 30)) + 'px) scale(' + (1 + p * 0.08) + ')';
      });
      if (glow) glow.style.opacity = String(0.8 + p * 0.2);
      ticking = false;
    }
    var onScreen = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        onScreen = en[0].isIntersecting;
        el.classList.toggle('is-off', !onScreen);
      }).observe(el);
    }
    window.addEventListener('scroll', function () {
      if (!onScreen || ticking) return;
      ticking = true; requestAnimationFrame(onScroll);
    }, { passive: true });
  }

  function highlights(root) {
    var track = root.querySelector('.hl__track');
    if (!track || track.dataset.wc4Init) return;
    track.dataset.wc4Init = '1';
    var sec = root.querySelector('.hl'), cards = track.querySelectorAll('.hl__card'),
        dotsWrap = root.querySelector('.hl__dots'), playBtn = root.querySelector('.hl__play'), icon = playBtn && playBtn.querySelector('svg');
    if (!cards.length || !dotsWrap) return;
    var DUR = (parseFloat(sec.dataset.interval) || 4) * 1000, idx = 0, playing = !reduce && !design, dots = [];
    var L = sec.dataset;
    cards.forEach(function (c, i) {
      var b = document.createElement('button');
      b.className = 'hl__dot'; b.type = 'button'; b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', String(i + 1));
      b.appendChild(document.createElement('i'));
      b.addEventListener('click', function () { go(i); });
      dotsWrap.appendChild(b); dots.push(b);
    });
    function setIcon() {
      if (!icon) return;
      icon.innerHTML = playing ? '<path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z"/>' : '<path d="M8 5v14l11-7z"/>';
      playBtn.setAttribute('aria-label', playing ? (L.pause || 'Pause') : (L.play || 'Play'));
    }
    // İlerleme çubuğu saf CSS animasyonu (GPU): JS her karede çalışmaz. Bölüm ekranda değilse ya da duraklatıldıysa durur.
    sec.style.setProperty('--hl-dur', DUR + 'ms');
    function paint() {
      cards.forEach(function (c, i) { c.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) {
        var on = i === idx, bar = d.firstChild;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
      });
    }
    function go(i) {
      idx = (i + cards.length) % cards.length;
      var c = cards[idx];
      track.scrollTo({ left: c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
      paint();
    }
    function state() { sec.classList.toggle('is-paused', !playing); }
    dotsWrap.addEventListener('animationend', function (e) {
      if (playing && e.target === dots[idx].firstChild) go(idx + 1);
    });
    if (playBtn) playBtn.addEventListener('click', function () { playing = !playing; setIcon(); state(); });
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bd = 1e9;
        cards.forEach(function (c, i) { var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (d < bd) { bd = d; best = i; } });
        if (best !== idx) { idx = best; paint(); }
      }, 120);
    }, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sec.classList.toggle('is-vis', en[0].isIntersecting); }).observe(track);
    } else { sec.classList.add('is-vis'); }
    state();
    setIcon(); paint();
  }

  function lineup(root) {
    var list = root.querySelector('.lineup');
    if (!list || list.dataset.wc4Init) return;
    list.dataset.wc4Init = '1';
    var sec = list.closest('.lineup-sec');
    function fit() { if (sec) sec.classList.toggle('is-scroll', list.scrollWidth > list.clientWidth + 4); }
    fit();
    window.addEventListener('resize', fit);
    window.addEventListener('load', fit);
    root.querySelectorAll('.arrow').forEach(function (b) {
      b.addEventListener('click', function () {
        var card = list.querySelector('.model');
        if (card) list.scrollBy({ left: Number(b.dataset.dir) * (card.offsetWidth + 14) * 3, behavior: 'smooth' });
      });
    });
  }


  function store(root) {
    var s = root.querySelector('[data-wc4-store]');
    if (!s || s.dataset.wc4Init) return;
    s.dataset.wc4Init = '1';
    var cards = [].slice.call(s.querySelectorAll('.pcard')), grid = s.querySelector('.pgrid'),
        chips = [].slice.call(s.querySelectorAll('[data-filter]')), sel = s.querySelector('[data-sort]'),
        lab = s.querySelector('[data-count-label]'), unit = lab ? lab.dataset.unit : '', current = '*';
    function has(card, f) { return f === '*' || card.dataset.c.indexOf(' ' + f + ' ') > -1; }
    chips.forEach(function (c) {
      var f = c.dataset.filter, n = cards.filter(function (x) { return has(x, f); }).length, el = c.querySelector('[data-n]');
      if (el) el.textContent = n + ' ' + unit;
      if (!n) c.hidden = true;
      c.addEventListener('click', function () {
        current = f;
        chips.forEach(function (x) { x.classList.toggle('is-active', x === c); x.setAttribute('aria-selected', x === c ? 'true' : 'false'); });
        apply();
      });
    });
    if (sel) sel.addEventListener('change', apply);
    function apply() {
      var vis = 0, v = sel ? sel.value : 'default';
      cards.forEach(function (x) { var ok = has(x, current); x.hidden = !ok; if (ok) vis++; });
      cards.slice().sort(function (a, b) {
        if (v === 'price-asc') return a.dataset.price - b.dataset.price;
        if (v === 'price-desc') return b.dataset.price - a.dataset.price;
        return a.dataset.i - b.dataset.i;
      }).forEach(function (x) { grid.appendChild(x); });
      if (lab) lab.textContent = vis + ' ' + unit;
    }
    apply();
  }

  function docs(root) {
    var row = root.querySelector('[data-wc4-docs]');
    if (!row || row.dataset.wc4Init) return;
    row.dataset.wc4Init = '1';
    var lb, img, cap, x, last;
    function close() {
      lb.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if (last) last.focus();
    }
    function build() {
      lb = document.createElement('div');
      lb.className = 'wc4 wc4-lb';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.innerHTML = '<button class="wc4-lb__x" type="button"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button><img alt=""><p></p>';
      x = lb.querySelector('button'); img = lb.querySelector('img'); cap = lb.querySelector('p');
      x.setAttribute('aria-label', row.dataset.close || 'Close');
      lb.addEventListener('click', function (ev) { if (ev.target === lb || ev.target.closest('.wc4-lb__x')) close(); });
      document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && lb.classList.contains('is-open')) close(); });
      document.body.appendChild(lb);
    }
    row.querySelectorAll('.doc').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!lb) build();
        last = b;
        img.src = b.dataset.full; img.alt = b.dataset.title || ''; cap.textContent = b.dataset.title || '';
        lb.setAttribute('aria-label', b.dataset.title || '');
        lb.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        x.focus();
      });
    });
  }

  function quietHidden() {
    document.querySelectorAll('.swiper-initialized').forEach(function (e) {
      if (e.offsetParent === null && e.swiper && !e.swiper.destroyed) {
        try { e.swiper.destroy(true, false); } catch (err) {}
      }
    });
  }
  if (document.querySelector('.wc4 .hero, .wc4 .lineup')) {
    window.addEventListener('load', function () { quietHidden(); setTimeout(quietHidden, 2500); setTimeout(quietHidden, 6000); });
  }

  function init(root) { reveal(root); hero(root); highlights(root); lineup(root); store(root); docs(root); }
  function initAll(scope) { (scope || document).querySelectorAll('.wc4').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
